export const tags = (t) => [
    { id: 'pages', label: t('discover.entity.tabs.pages') },
    { id: 'authors', label: t('discover.entity.tabs.authors') },
];
